<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'planSummary_courses_setGrade' | translate}}</h4>
</div>

<div class="modal-body">
    <div class="text-center">
        <qr-code *ngIf="url"
                 [value]="url"
                 size="200"
                 errorCorrectionLevel="M"></qr-code>
    </div>

    <div class="dl mt-2">
        <div>
            <span><i class="fi fi-rs-graduation-cap"></i></span>
            <span>{{resident?.Name}} {{resident?.Surname}}</span>
        </div>

        <div>
            <span><i class="fi fi-rs-document"></i></span>
            <span>[{{rotation?.Code}}] {{rotation?.Name}}</span>
        </div>

        <div>
            <span><i class="fi fi-rs-calendar-check"></i></span>
            <span>{{rotation?.DateFrom | appDate}} - {{rotation?.DateTo | appDate}}</span>
        </div>

        <div>
            <span><i class="fi fi-rs-marker"></i></span>
            <span>{{rotation?.CompanyName ?? ('planSummary_courses_lblPlaceUndefined' | translate)}}</span>
        </div>

        <div>
            <span><i class="fi fi-rs-user"></i></span>
            <span>
                <ng-container *ngIf="rotation?.Lecturers.length == 1">{{rotation?.Lecturers[0].Name}} {{rotation?.Lecturers[0].Surname}}</ng-container>
                <ng-container *ngIf="rotation?.Lecturers.length > 1">
                    <div *ngFor="let n of rotation?.Lecturers; let i = index" [class.mt-1]="i > 0">
                        <app-radio name="lecturer-{{i}}" [(ngModel)]="lecturer" [value]="n">{{n.Name}} {{n.Surname}}</app-radio>
                    </div>
                </ng-container>
            </span>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="close()">{{'close' | translate}}</button>
</div>
